import { forwardRef, type SVGProps } from 'react';

export interface FitToScreenIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const FitToScreenIcon = forwardRef<SVGSVGElement, FitToScreenIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 32 32">
    <path
      d="M2 10V6C2 3.791 3.791 2 6 2H10C10.552 2 11 2.448 11 3 11 3.552 10.552 4 10 4H6C4.895 4 4 4.895 4 6V10C4 10.552 3.552 11 3 11 2.448 11 2 10.552 2 10ZM28 10V6C28 4.895 27.105 4 26 4H22C21.448 4 21 3.552 21 3 21 2.448 21.448 2 22 2H26C28.209 2 30 3.791 30 6V10C30 10.552 29.552 11 29 11 28.448 11 28 10.552 28 10ZM28 26V22C28 21.448 28.448 21 29 21 29.552 21 30 21.448 30 22V26C30 28.209 28.209 30 26 30H22C21.448 30 21 29.552 21 29 21 28.448 21.448 28 22 28H26C27.105 28 28 27.105 28 26ZM2 26V22C2 21.448 2.448 21 3 21 3.552 21 4 21.448 4 22V26C4 27.105 4.895 28 6 28H10C10.552 28 11 28.448 11 29 11 29.552 10.552 30 10 30H6C3.791 30 2 28.209 2 26ZM22 9C22.552 9 23 9.448 23 10V22C23 22.552 22.552 23 22 23H10C9.448 23 9 22.552 9 22V10C9 9.448 9.448 9 10 9H22ZM11 21H21V11H11V21Z"
      fill="currentColor"
    />
  </svg>
));

FitToScreenIcon.displayName = 'FitToScreenIcon';
